import {SubsidiaryDao} from '../../dao';
import {ErrorModel, SubsidiaryModel} from '../../models';
import { UserState } from '../../reducers/UserReducer';
import {SERVICE_CODE} from './_serviceCode';

const FUNCTION_CODE = 'GET_ALL_SUBSIDIARIES';

export async function getAllSubsidiaries(
    userData: UserState["userProfileData"],
    params: string,
    page: number
) {
    try {
        const subsidiaries = await SubsidiaryDao.getAllSubsidiaries(userData?.userToken as string, params, page);

        const subsidiaryParsed = subsidiaries.results.map((subsidiary: Record<string, any>) => SubsidiaryModel.parseSubsidiary(subsidiary));

        return subsidiaryParsed;
    }
    catch (error) {
        throw ErrorModel.newError({
            code: `${SERVICE_CODE}/${FUNCTION_CODE}/ERROR`,
            message: 'Une erreur est survenue.',
            error: error
        });
    }
}
